import { render, staticRenderFns } from "./ConfirmAppt.vue?vue&type=template&id=f83dc54a&scoped=true&"
import script from "./ConfirmAppt.vue?vue&type=script&lang=js&"
export * from "./ConfirmAppt.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAppt.vue?vue&type=style&index=0&id=f83dc54a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83dc54a",
  null
  
)

export default component.exports